/**
 * Surveyor Messages screen — inbox for all surveyor conversations.
 * Shows: request chats (with clients) + support chats (with admin).
 */
import React, { useEffect } from 'react';
import { ChatInbox } from '../shared/ChatInbox';
import { useChatStore } from '../../store/chatStore';

export const SurveyorMessages: React.FC = () => {
  const { conversations, conversationsLoading, loadConversations, conversationsError } = useChatStore();

  useEffect(() => {
    loadConversations();
  }, [loadConversations]);

  if (conversationsLoading && conversations.length === 0) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%', color: '#636E72' }}>
        Loading messages...
      </div>
    );
  }

  if (conversationsError) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%', color: '#E17055' }}>
        {conversationsError}
      </div>
    );
  }

  return (
    <ChatInbox
      conversations={conversations}
      basePath="/surveyor"
      title="Messages"
      subtitle="Your survey chats and admin support"
    />
  );
};
